// components/Background.jsx
import React, { useState, useEffect } from 'react';

// Import images
import techBits from '../../pictures/background/tech/bits.jpg';
import techCode from '../../pictures/background/tech/code.jpg';
import techCode2 from '../../pictures/background/tech/code_2.jpg';
import techDesk from '../../pictures/background/tech/desk.jpg';

import proBits from '../../pictures/background/professional/code_professional.jpg';
import proMeeting from '../../pictures/background/professional/meeting.jpg';
import proReq from '../../pictures/background/professional/requirements.jpg';
import proWorking from '../../pictures/background/professional/working.jpg';

const themes = {
    tech: {
        backgroundImages: [
            techBits,
            techCode,
            techCode2,
            techDesk
        ]
    },
    professional: {
        backgroundImages: [
            proBits,
            proMeeting,
            proReq,
            proWorking
        ]
    }
};

// Rest of the component stays the same...

const Background = ({ theme }) => {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImage((prev) =>
                (prev + 1) % themes[theme].backgroundImages.length
            );
        }, 8000);
        return () => clearInterval(timer);
    }, [theme]);

    return (
        <div className="fixed inset-0 -z-10 overflow-hidden">
            {themes[theme].backgroundImages.map((src, index) => (
                <div
                    key={src}
                    className={`absolute inset-0 transition-opacity duration-1000
            ${currentImage === index ? 'opacity-100' : 'opacity-0'}`}
                >
                    <img
                        src={src}
                        alt=""
                        className="object-cover w-full h-full"
                        onError={(e) => {
                            console.warn(`Failed to load image: ${src}`);
                            e.target.src = '../../pictures/generic.svg';
                        }}
                    />
                </div>
            ))}
            <div
                className="absolute inset-0"
                style={{
                    background: theme === 'tech'
                        ? 'linear-gradient(to bottom, rgba(26, 26, 26, 0.85), rgba(26, 26, 26, 0.95))'
                        : 'linear-gradient(to bottom, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.95))',
                }}
            />
        </div>
    );
};

export default Background;